function labelForRatingsAndNoLevelSelected(numericalRatings: number[]): string {
  if (numericalRatings.length > 1) {
    return `Level ${numericalRatings.join(', ')} or No Level`
  }
  return `Level ${numericalRatings} or No Level`
}

function labelForRatings(numericalRatings: number[]): string {
  if (numericalRatings.length > 1) {
    return `Level ${numericalRatings.slice(0, -1).join(', ')} or ${numericalRatings.slice(-1)}`
  }
  return `Level ${numericalRatings[0]}`
}

function thereAreRatingsSelected(numericalRatings: number[]): boolean {
  return numericalRatings.length > 0
}

function noLevelSelected(selectedNetworkRatings: number[]): boolean {
  return selectedNetworkRatings.some(x => x === -1)
}

export function label(input: number[]): string {
  const selectedNetworkRatings = input.sort()
  const numericalRatings = selectedNetworkRatings.filter(x => x !== -1)
  const noLevel = noLevelSelected(selectedNetworkRatings)
  const thereAreRatings = thereAreRatingsSelected(numericalRatings)

  if (thereAreRatings && noLevel) {
    return labelForRatingsAndNoLevelSelected(numericalRatings)
  } else if (thereAreRatings) {
    return labelForRatings(numericalRatings)
  } else if (noLevel) {
    return 'No Level'
  }
  return 'Paths to QUALITY\u2122 Levels'
}
